import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
  resetMenu: boolean;
  topbarItemClick: boolean;
  activeTopbarItem: any;
  menuClick: boolean;
  topbarMenuActive: boolean;
  menuHoverActive: boolean;
  overlayMenuMobileActive: boolean;

  constructor() { }

  ngOnInit() {
  }

  onLayoutClick() {
    if (!this.topbarItemClick) {
      this.activeTopbarItem = null;
      this.topbarMenuActive = false;
    }

    if (!this.menuClick) {
      this.resetMenu = true;
      this.menuHoverActive = false;
    }

    this.topbarItemClick = false;
    this.menuClick = false;
  }

  onMenuButtonClick(event) {
    this.menuClick = true;
    this.topbarMenuActive = false;

    if (!this.isDesktop()) {
      this.overlayMenuMobileActive = !this.overlayMenuMobileActive;
    }
    event.preventDefault();
  }

  onMenuClick($event) {
    this.menuClick = true;
}

  onTopbarItemClick(event, item) {
    this.topbarItemClick = true;

    if (this.activeTopbarItem === item) {
      this.activeTopbarItem = null;
    } else {
      this.activeTopbarItem = item;
    }

    event.preventDefault();
  }

  onTopbarSubItemClick(event) {
    event.preventDefault();
  }

  isTablet() {
    const width = window.innerWidth;
    return width <= 1024 && width > 640;
  }

  isDesktop() {
    return window.innerWidth > 1024;
  }

  isMobile() {
    return window.innerWidth <= 640;
  }

  isHorizontal() {
    return true;
  }

  isOverlay() {
    return false;
  }
}
